import React, { useState } from "react";
import styles from "./DeleteConfirmModal.module.css";

const AlertTriangleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  showDeleteSurveys = false,
  loading = false,
}) => {
  const [deleteSurveys, setDeleteSurveys] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm({ deleteSurveys });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <button className={styles.modalClose} onClick={onClose} disabled={loading}>
          &times;
        </button>

        <div className={styles.modalBody}>
          <div className={styles.iconContainer}>
            <AlertTriangleIcon />
          </div>

          <h2 className={styles.title}>{title}</h2>

          {itemName && (
            <div className={styles.itemName}>
              <strong>{itemName}</strong>
            </div>
          )}

          <p className={styles.message}>{message}</p>

          {showDeleteSurveys && (
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={deleteSurveys}
                onChange={(e) => setDeleteSurveys(e.target.checked)}
                className={styles.checkbox}
                disabled={loading}
              />
              <span>Also delete survey responses</span>
            </label>
          )}

          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className={styles.btnDelete}
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className={styles.spinner}></span>
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
